function setItem<T extends string>(keyName: string, value: T): void {
  window.sessionStorage.setItem(keyName, value);
}

function getItem<T extends string>(keyName: string): T | null {
  return window.sessionStorage.getItem(keyName) as T | null;
}

function removeItem(keyName: string): void {
  window.sessionStorage.removeItem(keyName);
}

export const sessionStorageInstance = {
  setItem,
  getItem,
  removeItem,
};
